import { render } from "./ReservationInfo.vue?vue&type=template&id=a8ca06f0&scoped=true&ts=true"
import script from "./ReservationInfo.vue?vue&type=script&lang=ts"
export * from "./ReservationInfo.vue?vue&type=script&lang=ts"

import "./ReservationInfo.vue?vue&type=style&index=0&id=a8ca06f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ca06f0"]])

export default __exports__